import { render, staticRenderFns } from "./CpWidgets.vue?vue&type=template&id=23b501e4&scoped=true&"
import script from "./CpWidgets.vue?vue&type=script&lang=js&"
export * from "./CpWidgets.vue?vue&type=script&lang=js&"
import style0 from "./CpWidgets.vue?vue&type=style&index=0&id=23b501e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b501e4",
  null
  
)

export default component.exports